module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/subscriptionError_a71f455.gif";